/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для маски телефона
   */
  app.PhoneInputmaskView = app.View.extend({
    el: '.input_phone',
    masksOpts: '',
    currentCountryPhoneCode: '+7', // телефонный код текущей страны, по-умолчанию "+7" - Россия
    startPhoneNumbersCondition: true, // условие задания начальных цифр в поле
    maskCondition: true, // условие установки маски
    prevInputValue: '',
    ruCountryCodeAnalogEntered: false,
    ruCountryCodeAnalog: '8',
    withRuCountryCodeAutoRemove: false,
    events: {
      'keypress': 'handleKeypress',
    },
    run: function (options) {
      this.withRuCountryCodeAutoRemove = app.features.is_country_code_auto_remove;
      if (this.$el.val()) {
        this.startPhoneNumbersCondition = false;
      }
      
      var maskList = this.getPhoneCode2Country();

      if (!this.model) {
        this.model = app.countryFlag;
      }
      
      this.maskOpts = {
        inputmask: {
          definitions: {
            '#': {
              validator: '[0-9]',
              cardinality: 1
            }
          },
          showMaskOnHover: false,
          autoUnmask: true
        },
        match: /[0-9]/,
        replace: '#',
        list: maskList,
        listKey: 'mask',
        onMaskChange: this.onMaskChange.bind(this)
      };
      
      this.model.on('change:code', this.updateCountryMask, this);
      if (options && options.startPhoneNumbersCondition) {
        this.startPhoneNumbersCondition = options.startPhoneNumbersCondition;
      }
      if (options && options.maskCondition) {
        this.maskCondition = options.maskCondition;
      }
      this.updateCountryMask();
    },

    /**
     * Обработка нажатия клавиши.
     * @param {Event} e Событие нажатия.
     */
    handleKeypress: function (e) {
      var currentValue = this.$el.val();

      // прерываем нажатие, после первой попытки ввести "8" после кода "+7"
      if (
        this.withRuCountryCodeAutoRemove
        && this.maskOpts.list[0].cc === 'RU'
        && currentValue === this.maskOpts.list[0].countryCode
        && e.key === this.ruCountryCodeAnalog
      ) {
        if (!this.ruCountryCodeAnalogEntered) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
        this.ruCountryCodeAnalogEntered = !this.ruCountryCodeAnalogEntered;
      } else {
        this.ruCountryCodeAnalogEntered = false;
      }
      this.prevInputValue = currentValue;
    },

    /**
     * Обработка изменения маски.
     * @param {Object} maskData Данные маски.
     */
    onMaskChange: function (maskData) {
      // проверяем, можно ли ставить маску
      if (!this.isCanSetMask()) {
        return;
      }

      // устанавливаем placeholder таким же как и видимая маска ввода
      var mask = this.$el.inputmask('getemptymask');
      mask = Array.isArray(mask) ? mask.join('') : mask;
      var val = maskData.countryCode;
      for (var i in val) {
        if (val.hasOwnProperty(i)) {
          mask = mask.replace('_', val[i]);
        }
      }
      this.$el.attr('placeholder', mask);
    },
    
    save: function () {
      if (
        this.$el.val()
        && this.$el.val() !== this.currentCountryPhoneCode.replace('+', '')
        && this.model.get('id') !== 1
      ) {
        var phone = this.$el.val().replace(/\D*/, '');
        this.model.set({ id: phone });
        this.model.save();
      }
    },
    
    /**
     * Навешивает маску
     */
    render: function () {
      this.updateMask();
      this.$el.change();
    },
    
    /**
     * Обновление маски
     */
    updateMask: function () {
      if (!this.isCanSetMask()) {
        return;
      }
      if (!this.getIsOther()) {
        this.$el.inputmasks(this.maskOpts);
        return;
      }
      this.$el.inputmask({'mask': '9', 'repeat': '15', 'greedy': false});
      this.$el.removeAttr('placeholder');
      var previous = '+7';
      if (this.model._previousAttributes && this.model._previousAttributes.code) {
        previous = this.model._previousAttributes.code;
      }
      if (previous && (previous === this.$el.val() || this.$el.val() === previous.replace('+', ''))) {
        this.$el.val('');
      }
    },
    
    /**
     * Можно ли ставить маску
     */
    isCanSetMask: function () {
      if (typeof this.maskCondition === 'function') {
        return this.maskCondition();
      }
      
      return this.maskCondition;
    },
    
    /**
     * Удаляет маску
     */
    removeMask: function () {
      this.$el.inputmask('remove');
    },
    
    /**
     * Меняет код страны и маску телефона а так же задаёт начальное значение если это необходимо
     */
    updateCountryMask: function () {
      // запоминаем установленный код
      this.currentCountryPhoneCode = this.model.get('code') || this.currentCountryPhoneCode;
      
      // обновляем список масок
      this.maskOpts.list = this.getPhoneCode2Country(this.model.get('nameEn'));
      // ставим новую маску
      this.updateMask();
      
      //если инпут пустой, то возвращаем возможность заполнять поле начальным значением
      if (!this.$el.val() && this.$el.attr('type') === 'tel') {
        this.startPhoneNumbersCondition = true;
      }
      // установка начального значения поля
      if (this.isCanUpdate() && !this.getIsOther()) {
        this.setPhoneCodeValue(this.getPhoneCode());
      }
    },
    
    /**
     * Возвращает текущий телефонный код
     * @returns {string}
     */
    getPhoneCode: function () {
      return this.currentCountryPhoneCode;
    },
    
    /**
     * Устанавливает начальный код телефона в поле формы
     * @param {String }code
     */
    setPhoneCodeValue: function (code) {
      this.$el.val(code);
    },
    
    /**
     * Определяет, можно ли обновлять значение поля
     * @returns {boolean}
     */
    isCanUpdate: function () {
      if (typeof this.startPhoneNumbersCondition === 'function') {
        return this.startPhoneNumbersCondition();
      }
      
      return this.startPhoneNumbersCondition;
    },
    
    /**
     * Возвращает список масок телефона для стран
     * @returns {[]}
     */
    getPhoneCodeList: function () {
      if (this.phoneCodeList) {
        return this.phoneCodeList;
      }
      this.phoneCodeList = $.masksSort(app.phoneCodes, ['#'], /[0-9]|#/, 'mask');
      
      return this.phoneCodeList;
    },
    
    /**
     * Возвращает список масок телефона для страны
     * @param {String} countryName название страны на английском
     * @returns {[]}
     */
    getPhoneCode2Country: function (countryName) {
      countryName = countryName ? countryName : 'russia'; // если ничего не задано - будет Россия
      
      return this.getPhoneCodeList().filter(function (maskObj) {
        return maskObj.name_en.toLowerCase() === countryName.toLowerCase();
      });
    },
    
    /**
     * Определяем, что выбрана Другая страна
     * @returns {boolean}
     */
    getIsOther: function () {
      if (this.maskOpts && ((_.isArray(this.maskOpts) && this.maskOpts[0].cc === 'OT') || (_.isObject(this.maskOpts) && this.maskOpts.list[0].cc === 'OT'))) {
        return true;
      }
      return false;
    }
  });
  
})(jQuery);

}.call(window));